export default __webpack_public_path__ + "static/media/wordpairs_locked_crown.62947ba5.svg";